const equipamentosDetalhes = {
  "INTERFOLHA DUAS DOBRAS - US210": {
    imagens: [
      "/1-000001-1-2.jpg",
      "/1-000001-2-1.jpg",
      "/1-000001-3-1.jpg"
    ],
    dimensoes: [
      "Peso: 750 Kg",
      "Altura: 1.200 mm",
      "Largura: 1.400 mm",
      "Comprimento: 3.640 mm",
      "Voltagem: 220 Volts"
    ],
    caracteristicas: [
      "Estrutura lateral em ferro fundido, espessura 50mm.",
      "Rolamento de agulhas primeira linha.",
      "02 conjuntos de gofradores contínuos aço/borracha.",
      "Desenho do gofrador personalizado (opcional).",
      "Entrada independente para 2 bobinas com:",
      "› 60 ou 69cm de largura.",
      "› Diâmetro (Ø) de 80cm.",
      "Conjunto de discos de corte vertical tracionado por engrenagens.",
      "Sistema de corte horizontal por serrilha.",
      "02 Conjuntos de freios.",
      "Mesa de saída com aparadores frontais.",
      "Transporte por agulhas.",
      "Contador digital de 1 a 1.999 folhas.",
      "Marcador com acionamento elétrico.",
      "Inversor de frequência",
      "Motor de 3 CV.",
      "Produção: 80/125 fardos de 1.000 folhas/hora.",
      "Saída tripla, tamanho da toalha 23×21/20×21/19×21."
    ],
    videos: [
      "https://www.youtube.com/embed/E8Tz6Vom02I?si=OQuMm-5OaGRlIBH8",
      "https://www.youtube.com/embed/rCpCGKddN9k?si=pU50FCuC7H3WnnDj"
    ],
    catalogo: "/pdfs/1-000001-MAQUINA-DE-PAPEL-TOALHA-DUAS-DOBRAS-US-210-1.pdf",
    whatsapp: "https://wa.me/5511999999999?text=Olá! Gostaria de saber mais sobre INTERFOLHA DUAS DOBRAS - US210"
  },

    "SERRA FITA PARA ROLÃO – USR800": {
    imagens: [
      "/4-000001-1.jpg",
      "/4-000001-2.jpg",
      "/4-000001-3.jpg"
    ],
    dimensoes: [
      "Peso: 470kg",
      "Altura: 2.115mm",
      "Largura: 1.000mm",
      "Comprimento: 3.000mm",
      "Voltagem: 220/380 volts"
    ],
    caracteristicas: [
      "Estrutura construtiva principal (Tubo de aço 90x90x4.75mm).",
      "Potência instalada (Motor de 3CV trifásico)",
      "Chave de Partida 3CV 10AMP.",
      "Compartimento condicionador de Logs com guias lineares.",
      "A ador de lâmina com Tripla Regulagem.",
      "Polias principais da ta com Ø800 mm.",
      "01 Fita de corte larg. 50mm x esp. 0.9mm x comp. 4.800mm.",
      "Comprimento de corte com regulagem de 10cm a 70cm.",
      "Comporta rolo com Ø mínimo de 80mm Ø máximo de 250mm.",
      "Compartimento para logs de papel toalha duas dobras (opcional).",
      "Corte de rolos de Papel Higiênico larg. 10cm x 30 a 600mts.",
      "Corte de Papel Toalha em Bobinas larg. 20cm x 100 a 200mts.",
      "Corte de Lençol Hospitalar com comprimento de 50cm a 70cm.",
      "Corte de Papel Toalha Duas Dobras (opcional)."
    ],
    videos: [
      "https://www.youtube.com/embed/Lj6M4tHfJeY?si=bijoWgvnt90F6HU9"
    ],
    catalogo: "/pdfs/4-000001-SERRAFITAPARAROLAO-USR800.pdf"
  },

  "PRENSA ENFARDADEIRA - US690": {
  imagens: [
    "/5-000001-1-1.jpg",
    "/5-000001-3.jpg",
    "/5-000001-2-1.jpg"
  ],
  dimensoes: [
    "Peso: 80 Kg",
    "Altura: 930 mm",
    "Largura: 650 mm",
    "Comprimento: 1.300 mm"
  ],
  caracteristicas: [
    "Sistema com cilindros e válvulas pnemáticos",
    "Conjunto de regulador de pressão e filtro",
    "Acionamento dos pistões por pedal.",
    "Prensa e enfarda maço de papel toalha duas dobras com 250 folhas em saco plástico.",
    "Produção compatível com outras operações."
  ],
  videos: [
    "https://www.youtube.com/embed/rCpCGKddN9k?si=R27ky51nbcTkhUsR",
    "https://www.youtube.com/embed/o1CoZ50XynM?si=Tsp2idFVu7tWTm6d"
  ],
  catalogo: "/pdfs/5-000001-PRENSAENFARDADEIRA-US690.pdf"
},

"INTERFOLHA DUAS DOBRAS VÁCUO - US1300": {
  imagens: [
    "/7-003001-1-3.jpg",
    "/7-003001-1-3.jpg",
    "/7-003001-3.jpg",
  ],
  dimensoes: [
    "Peso: 6.500 Kg",
    "Altura: 2.127 mm",
    "Largura: 2.400 mm",
    "Comprimento: 8.966 mm",
    "Voltagem: 220v/380v"
  ],
  caracteristicas: [
    "01 Motor 10 CV acionado por inversor de frequência 10 CV.",
    "01 Motor 30 CV acionado por Soft-Starter.",
    "Bomba de vácuo de alta intensidade de sucção.",
    "Desbobinador pneumático através de correias sincronizada.",
    "Sistema pneumático de elevação das bobinas.",
    "Contador de folhas digital de 1 a 999.",
    "Comporta bobinas jumbo de 1260mm de largura x Ø máximo de 1200mm.",
    "Dois pares de gofradores aço/borracha sendo o de aço com desenho personalizado e com sistema pneumático de pressão.",
    "Regulagem continua da taxa de velocidade e ajuste da tensão do papel.",
    "Painel de operação panorâmico, fácil acesso e total controle.",
    "Converte grande amplitude de gramaturas tanto alta, como baixa, devido a essa amplitude é possível produzir PAPEL TOALHA DUAS DOBRAS com várias medidas como: 23×21, 22×21, 20×21 e etc…",
    "PAPEL HIGIÊNICO TIPO CAI-CAI e GUARDANAPOS DE MESA INTERFOLHADO.",
    "Sincronismo perfeito de corte, dobra e contagem integrados, A VÁCUO US 1300 proporciona um grande acréscimo à qualidade, alta produtividade, intercalação e dobra perfeita, excelente acabamento final e aparência impecáveis, requisitos estes altamente aclamado pelos nossos clientes."
  ],
  videos: [
    "https://www.youtube.com/embed/N5HUJX_10pQ?si=F87dqgv85VWacdfX"
  ],
  catalogo: "/pdfs/7-003001-MAQUINA-INTERFOLHA-DUAS-DOBRAS-VACUO-US-1300-1.pdf"
},

  "TUBETEIRA – US80": {
  imagens: [
    "/8-000001-2-2-1.jpg",
    "/8-000001-3.jpg",
    "/8-000001-1.jpg"
  ],
  dimensoes: [
    "Peso: 490 Kg",
    "Altura: 1.600 mm",
    "Largura: 4.600 mm",
    "Comprimento: 5.300 mm",
    "Voltagem: 220/380 volts"
  ],
  caracteristicas: [
    "01 Motor 3CV.",
    "Produção aproximada de 2/4 metros/min.",
    "Comporta mandril para tubete de papel higiênico, papel toalha em bobina e lençol hospitalar.",
    "Sistema de acionamento e controle de velocidade através de inversor de frequência.",
    "Coleiro em aço inox com aquecimento e controle de temperatura automático.",
    "Colagem por imersão.",
    "Numero máximo de fitas: 04 fitas.",
    "Suporte para 04 rolos de maculatura."
  ],
  videos: [
    "https://www.youtube.com/embed/_hZ8tgDzpTA?si=2XrdpuUi1XO56NdE"
  ],
  catalogo: "/pdfs/8-000001-TUBETEIRA-US08.pdf"
},

"REBOBINADEIRA – US3000": {
  imagens: [
    "/9-000001-1-3.jpg",
    "/9-000001-2.jpg",
    "/9-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 4.900 Kg",
    "Altura: 2.300 mm",
    "Largura: 4.600 mm",
    "Comprimento: 2.100 mm",
    "Voltagem: 220/380 volts"
  ],
  caracteristicas: [
    "Componentes elétrico/eletrônicos primeira linha.",
    "Motor de 20cv.",
    "Programado através de PLC (Power Line Communication).",
    "Tela IHM (Interface Homem-Máquina) Touch Screen.",
    "Gofrador de aço com desenho personalizados.",
    "Gofrador de borracha com regulagem de pressão pneumática.",
    "Barra curva para eliminação de possíveis rugas no papel.",
    "Colador com feltro submerso com acionamento pneumático.",
    "Conjunto de picote acionado por pneumático (opcional).",
    "Prensa com mecanismo eletro pneumático, com controle de pressão dos logs.",
    "Comporta bobina jumbo 1.200mm de diâmetro x 3.000mm de comprimento.",
    "Produção máxima: 300 mts/min.",
    "Rebobina papel higiênico.",
    "Rebobina lençol hospitalar.",
    "Rebobina papel toalha em bobina."
  ],
  catalogo: "/pdfs/9-000001-REBOBINADEIRA-US3000.pdf"
},

"SERRA FITA PARA PAPEL INTERFOLHA – USI800": {
  imagens: [
    "/4-000001-1-3.jpg",
    "/10-000001-2.jpg",
    "/10-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 470 Kg",
    "Altura: 2.115 mm",
    "Largura: 1.000 mm",
    "Comprimento: 3.000 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Estrutura construtiva principal (Tubo de aço 90x90x4.75mm).",
    "Potência instalada (Motor de 3CV).",
    "Chave de Partida 3CV 10AMP 220V.",
    "Compartimento condicionador de Logs com guias lineares.",
    "A ador de lâmina com Tripla Regulagem.",
    "Polias principais da ta com Ø800 mm.",
    "01 Fita de corte larg. 50mm x esp. 0.9mm x comp. 4.800mm.",
    "Corte de maços de papel toalha duas dobras com precisão.",
    "Alta produtividade e confiabilidade."
  ],
  catalogo: "/pdfs/10-000001-SERRAFITAPARAPAPELINTERFOLHA-US1800.pdf"
},


"CORTADEIRA AUTOMÁTICA DE PAPEL TOALHA - US610": {
  imagens: [
    "/12-000001-2-3.jpg",
    "/12-000001-1.jpg",
    "/12-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 750 Kg",
    "Altura: 1.920 mm",
    "Largura: 1.776 mm",
    "Comprimento: 2.722 mm",
    "Voltagem: 220/380 volts"
  ],
  caracteristicas: [
    "Possui componentes eletroeletrônicos primeira linha.",
    "Programa Operacional através de PLC (Power Line Communications).",
    "Controle operacional através de tela IHM (Interface Homem Máquina) Touch Screen.",
    "Formulação e salvamento de receitas dimensional a ser cortada com observações.",
    "Controle Dimensional.",
    "Acionamento manual/automático.",
    "Disco de corte com diâmetro 610mm Ø.",
    "01 par de rebolos com a ação diamantada.",
    "Tempo de a ação programada.",
    "Posicionamento automático do disco.",
    "Travamento das portas automático.",
    "Produção automática de até 60 golpes p/min.",
    "NR-12"
  ],
  videos: [
    "https://www.youtube.com/embed/Eio-WdNifEI?si=n-DGMmH-HUbX2faL"
  ],
  catalogo: "/pdfs/12-000001-CORTADEIRAAUTOMATICADEPAPELTOALHA-US610.pdf"
},

"ESTEIRA DE SAÍDA 4 MTS - US4000": {
  imagens: [
    "/12-100001-1.jpg",
    "/12-100001-2.jpg",
    "/12-100001-3.jpg"
  ],
  dimensoes: [
    "Peso: 100 Kg",
    "Altura: 940 mm",
    "Largura: 500 mm",
    "Comprimento: 4.000 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Motorredutor 05 CV.",
    "Correia transportadora FUN7/2E.",
    "Pintura em PU.",
    "Velocidade máxima 18 metros p/ minuto.",
    "Transportadora de Papel Toalha Duas Dobras: Pacote de 250 folhas – 23×21/20×21/20×20/23×20/23×19/20×19"
  ],
  videos: [
    "https://www.youtube.com/embed/_1VddDWu_Bc?si=l4VJWt2VytTPNTJ_"
  ],
  catalogo: "/pdfs/12-100001-ESTEIRADESAIDA4MTS-US4000.pdf"
},

"ESTEIRA DE ENTRADA 6 MTS - US6000": {
  imagens: [
    "/12-200001-1-2.jpg",
    "/12-200001-2.jpg",
    "/12-200001-3.jpg"
  ],
  dimensoes: [
    "Peso: 140 Kg",
    "Altura: 940 mm",
    "Largura: 500 mm",
    "Comprimento: 6.000 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Motorredutor 05 CV.",
    "Correia transportadora FUN7/2E.",
    "Pintura em PU.",
    "Velocidade máxima 18 metros p/ minuto.",
    "Transportadora de Papel Toalha Duas Dobras: Pacote de 250 folhas – 23×21/20×21/20×20/23×20/23×19/20×19"
  ],
  videos: [
    "https://www.youtube.com/embed/_1VddDWu_Bc?si=_vxVw7kHXJKWkpBL"
  ],
  catalogo: "/pdfs/12-200001-ESTEIRADEENTRADA6MTS-US6000.pdf"
},

"ESTEIRA DE SAÍDA 10 MTS - US10000": {
  imagens: [
    "/12-300001-1-4-1.jpg",
    "/12-300001-2.jpg",
    "/12-300001-3.jpg"
  ],
  dimensoes: [
    "Peso: 210 Kg",
    "Altura: 940 mm",
    "Largura: 500 mm",
    "Comprimento: 10.000 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Motorredutor 05 CV.",
    "Correia transportadora FUN7/2E.",
    "Pintura em PU.",
    "Velocidade máxima 18 metros p/ minuto.",
    "Transportadora de Papel Toalha Duas Dobras: Pacote de 250 folhas – 23×21/20×21/20×20/23×20/23×19/20×19"
  ],
  videos: [
    "https://www.youtube.com/embed/_1VddDWu_Bc?si=6I__T20K8atJaZ9J"
  ],
  catalogo: "/pdfs/12-300001-ESTEIRADESAIDA10MTS-US10000.pdf"
},

"BOMBA DE VACUO COMPLETA - US150": {
  imagens: [
    "/16-000001-1-2-1.jpg",
    "/16-000001-2.jpg",
    "/16-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 900 Kg",
    "Altura: 1.650 mm",
    "Largura: 860 mm",
    "Comprimento: 3.010 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Motor de 30 CV",
    "Sistema de feltro",
    "Sistema de escapamento",
    "Produção de vácuo compatível com US 1300 e US 1600"
  ],
  catalogo: "/pdfs/16-000001-BOMBADEVACUOCOMPLETA-US150.pdf"
},

"GUARDANAPEIRA – US140": {
  imagens: [
    "/29-000001-1-4.jpg",
    "/29-000001-2.jpg",
    "/29-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 1.200 Kg",
    "Altura: 1.860 mm",
    "Largura: 1.250 mm",
    "Comprimento: 3.175 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Contador digital de folhas.",
    "Gofrador personalizado.",
    "Mesa em aço inox.",
    "02 Motores de 3CV.",
    "01 Inversor de frequência de 3CV.",
    "Pista Dupla: 20×20/30×30 (medidas a combinar).",
    "Produção: 140 fardos de 5.000 unidades, turno de 8 horas."
  ],
  videos: [
    "https://www.youtube.com/embed/2aXA2wt6Qss?si=Zmf3OKtrqKW0fPmp"
  ],
  catalogo: "/pdfs/29-000001-GUARDANAPEIRA-US140.pdf"
},

"SERRA FITA PARA ROLAO AUTOMÁTICA – US300": {
  imagens: [
    "/25-000001-2-1.jpg",
    "/25-000001-1.jpg",
    "/25-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 1.800 Kg",
    "Altura: 2.440 mm",
    "Largura: 3.385 mm",
    "Comprimento: 5.730 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Componentes eletrônicos de primeira linha.",
    "Programação através de PLC (Power Line Communications).",
    "Controle operacional via tela IHM (Touch Screen).",
    "Formulação e salvamento de receitas variadas, segundo necessidades de produtos.",
    "Controle dimensional com precisão milimétrica.",
    "Operação automática.",
    "Esteira de saída integrada, (esteira de saída opcional).",
    "Rebolos de afiação com acionamento elétrico.",
    "Velocidade de produção ajustável.",
    "Produção automática de até 45 golpes por minuto.",
    "NR-12"
  ],
  videos: [
    "https://www.youtube.com/embed/5WilXR8MSmY?si=4Hy3okdn7KE4isCP"
  ],
  catalogo: "/pdfs/25-000001-SERRAFITAPARAROLAOAUTOMATICA-US300.pdf"
},

"ENFARDADEIRA BAG – US5000": {
  imagens: [
    "/28-000001-2.jpg",
    "/28-000001-1.jpg",
    "/28-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 340 Kg",
    "Altura: 1.400 mm",
    "Largura: 1.240 mm",
    "Comprimento: 3.000 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Componentes eletroeletrônicos de 1ª linha.",
    "Programado através de PLC (Power Line Communications).",
    "Controle operacional via tela IHM (Touch Screen).",
    "Operação automática / manual.",
    "Cabeças para enfardar com selagem através de mordentes.",
    "Produção automática de até 2 bags p/min."
  ],
  videos: [
    "https://www.youtube.com/embed/8rfp1PlI-Is?si=TaEi70hdffR6CnsT"
  ],
  catalogo: "/pdfs/28-000001-ENFARDADEIRABAG-US5000.pdf"
},

"ENFARDADEIRA – US400": {
  imagens: [
    "/23-000001-1.jpg",
    "/23-000001-2.jpg",
    "/23-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 1.200 Kg",
    "Altura: 1.400 mm",
    "Largura: 2.300 mm",
    "Comprimento: 5.545 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Componentes eletrônicos de primeira linha.",
    "Programado através de PLC (Power Line Communications).",
    "Controle operacional via tela IHM (Touch Screen).",
    "03 Esteiras independentes acionadas por motorredutor 1:10 com MOTOR 0,33 CV.",
    "Operação automática / manual.",
    "Duas cabeças para enfardar com selagem através de mordente.",
    "Produção automática de até 10 pacotes por minuto."
  ],
  videos: [
    "https://www.youtube.com/embed/0-cgvkzIB-Q?si=wevDROpRXkpUQXne"
  ],
  catalogo: "/pdfs/23-000001-ENFARDADEIRA-US400.pdf"
},

"GUARDANAPEIRA - US70": {
  imagens: [
    "/3-000001-1.jpg",
    "/3-000001-2.jpg",
    "/3-000001-3.jpg"
  ],
  dimensoes: [
    "Peso: 1.200 Kg",
    "Altura: 1.635 mm",
    "Largura: 1.240 mm",
    "Comprimento: 2.700 mm",
    "Voltagem: 220/380 Volts"
  ],
  caracteristicas: [
    "Contador digital de folhas.",
    "Gofrador personalizado.",
    "Mesa em aço inox.",
    "02 Motores de 3CV.",
    "01 Inversor de frequência de 3CV.",
    "Pista simples: 20×20/30×30 (medidas a combinar)",
    "Produção: 70 fardos de 5.000 unidades, turno de 8 horas."
  ],
  videos: [
    "https://www.youtube.com/embed/0rZzObu0pwI?si=atQzNuot18UbgMRl"
  ],
  catalogo: "/pdfs/3-000001-GUARDANAPEIRA-US70.pdf"
},

"REBOBINADEIRA – US2500": {
  imagens: [
    "/2-000001-2.jpg",
    "/2-000001-3.jpg",
    "/2-000001-1.jpg"
  ],
  dimensoes: [
    "Peso: 4.450 Kg",
    "Altura: 2.400 mm",
    "Largura: 4.000 mm",
    "Comprimento: 2.200 mm",
    "Voltagem: 220/380 volts"
  ],
  caracteristicas: [
    "Componentes eletroeletrônicos de primeira linha.",
    "Motor de 15cv.",
    "Programado através de PLC (Power Line Communication).",
    "Tela IHM (Interface Homem-Máquina) Touch Screen.",
    "Gofrador de aço com desenho personalizados.",
    "Gofrador de borracha com regulagem de pressão pneumática.",
    "Barra curva para eliminação de possíveis rugas no papel.",
    "Colador com feltro submerso com acionamento pneumático.",
    "Conjunto de picote acionado por pneumático (opcional).",
    "Prensa com mecanismo eletro pneumático, com controle de pressão dos logs.",
    "Comporta uma bonina jumbo 1.000mm de diâmetro x 2.450mm.",
    "Produção máxima: 300 mts/min.",
    "Rebobina papel higiênico.",
    "Rebobina lençol hospitalar.",
    "Rebobina papel toalha em bobina."
  ],
  videos: [
    "https://www.youtube.com/embed/CLo0QjJvo0g?si=fIwEH7iAG3cbhl-m"
  ],
  catalogo: "/pdfs/2-000001-REBOBINADEIRA-US-2500-1.pdf"
},

  
};

export default equipamentosDetalhes;

